import { render, staticRenderFns } from "./Arguments.vue?vue&type=template&id=7b8e1ab1&"
import script from "./Arguments.vue?vue&type=script&lang=js&"
export * from "./Arguments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports